import {
  Companion_getInstance1h9pz6hxur4uj as Companion_getInstance,
  PayApplicationmbkdcq3ut87x as PayApplication,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(PayApplication_project_getInstance());
}
function get_description(_this__u8e3s4) {
  return _this__u8e3s4.prop(PayApplication_description_getInstance());
}
function get_number(_this__u8e3s4) {
  return _this__u8e3s4.prop(PayApplication_number_getInstance());
}
function preparePayApplicationFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [PayApplication__id_getInstance(), PayApplication_project_getInstance(), PayApplication_number_getInstance(), PayApplication_created_getInstance(), PayApplication_submitted_getInstance(), PayApplication_description_getInstance(), PayApplication_attachments_getInstance(), PayApplication_readBy_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function PayApplication_project$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function PayApplication_project$_get_name_$ref_tnhks1() {
  return (p0) => p0.i20();
}
function PayApplication_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayApplication_project$_get_serializer_$ref_p9hksq() {
  return (p0) => p0.h2j();
}
function PayApplication_project$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function PayApplication_project$_get_annotations_$ref_e9srie() {
  return (p0) => p0.bz();
}
var PayApplication_projectClass;
function PayApplication_project() {
  if (PayApplication_projectClass === VOID) {
    class $ {
      constructor() {
        PayApplication_project_instance = this;
        var tmp = this;
        tmp.c6y_1 = lazy(PayApplication_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d6y_1 = lazy(PayApplication_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e6y_1 = lazy(PayApplication_project$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.c6y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayApplication_project$_get_name_$ref_tnhks1(), null);
        return tmp0.f2();
      }
      f6y(receiver) {
        return receiver.h6y_1;
      }
      k2j(receiver) {
        return this.f6y(receiver instanceof PayApplication() ? receiver : THROW_CCE());
      }
      o6y(receiver, value) {
        return receiver.p6y(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PayApplication() ? receiver : THROW_CCE();
        return this.o6y(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d6y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayApplication_project$_get_serializer_$ref_p9hksq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e6y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayApplication_project$_get_annotations_$ref_e9srie(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayApplication_project', VOID, VOID, [SerializableProperty()]);
    PayApplication_projectClass = $;
  }
  return PayApplication_projectClass;
}
var PayApplication_project_instance;
function PayApplication_project_getInstance() {
  if (PayApplication_project_instance === VOID)
    new (PayApplication_project())();
  return PayApplication_project_instance;
}
function PayApplication_description$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function PayApplication_description$_get_name_$ref_u8oxim() {
  return (p0) => p0.i20();
}
function PayApplication_description$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayApplication_description$_get_serializer_$ref_j4libr() {
  return (p0) => p0.h2j();
}
function PayApplication_description$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function PayApplication_description$_get_annotations_$ref_8lx9st() {
  return (p0) => p0.bz();
}
var PayApplication_descriptionClass;
function PayApplication_description() {
  if (PayApplication_descriptionClass === VOID) {
    class $ {
      constructor() {
        PayApplication_description_instance = this;
        var tmp = this;
        tmp.q6y_1 = lazy(PayApplication_description$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r6y_1 = lazy(PayApplication_description$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s6y_1 = lazy(PayApplication_description$annotations$delegate$lambda);
        this.t6y_1 = '';
        this.u6y_1 = '""';
      }
      i20() {
        var tmp0 = this.q6y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayApplication_description$_get_name_$ref_u8oxim(), null);
        return tmp0.f2();
      }
      f6y(receiver) {
        return receiver.l6y_1;
      }
      k2j(receiver) {
        return this.f6y(receiver instanceof PayApplication() ? receiver : THROW_CCE());
      }
      v6y(receiver, value) {
        return receiver.p6y(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PayApplication() ? receiver : THROW_CCE();
        return this.v6y(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r6y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayApplication_description$_get_serializer_$ref_j4libr(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s6y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayApplication_description$_get_annotations_$ref_8lx9st(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayApplication_description', VOID, VOID, [SerializableProperty()]);
    PayApplication_descriptionClass = $;
  }
  return PayApplication_descriptionClass;
}
var PayApplication_description_instance;
function PayApplication_description_getInstance() {
  if (PayApplication_description_instance === VOID)
    new (PayApplication_description())();
  return PayApplication_description_instance;
}
function PayApplication_number$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function PayApplication_number$_get_name_$ref_li09sd() {
  return (p0) => p0.i20();
}
function PayApplication_number$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayApplication_number$_get_serializer_$ref_xrx0r0() {
  return (p0) => p0.h2j();
}
function PayApplication_number$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function PayApplication_number$_get_annotations_$ref_yiy8w8() {
  return (p0) => p0.bz();
}
var PayApplication_numberClass;
function PayApplication_number() {
  if (PayApplication_numberClass === VOID) {
    class $ {
      constructor() {
        PayApplication_number_instance = this;
        var tmp = this;
        tmp.w6y_1 = lazy(PayApplication_number$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x6y_1 = lazy(PayApplication_number$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y6y_1 = lazy(PayApplication_number$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.w6y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayApplication_number$_get_name_$ref_li09sd(), null);
        return tmp0.f2();
      }
      f6y(receiver) {
        return receiver.i6y_1;
      }
      k2j(receiver) {
        return this.f6y(receiver instanceof PayApplication() ? receiver : THROW_CCE());
      }
      z6y(receiver, value) {
        return receiver.p6y(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PayApplication() ? receiver : THROW_CCE();
        return this.z6y(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x6y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayApplication_number$_get_serializer_$ref_xrx0r0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y6y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayApplication_number$_get_annotations_$ref_yiy8w8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayApplication_number', VOID, VOID, [SerializableProperty()]);
    PayApplication_numberClass = $;
  }
  return PayApplication_numberClass;
}
var PayApplication_number_instance;
function PayApplication_number_getInstance() {
  if (PayApplication_number_instance === VOID)
    new (PayApplication_number())();
  return PayApplication_number_instance;
}
function PayApplication__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function PayApplication__id$_get_name_$ref_xg2jw0() {
  return (p0) => p0.i20();
}
function PayApplication__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayApplication__id$_get_serializer_$ref_43xl3d() {
  return (p0) => p0.h2j();
}
function PayApplication__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function PayApplication__id$_get_annotations_$ref_us00kl() {
  return (p0) => p0.bz();
}
var PayApplication__idClass;
function PayApplication__id() {
  if (PayApplication__idClass === VOID) {
    class $ {
      constructor() {
        PayApplication__id_instance = this;
        var tmp = this;
        tmp.a6z_1 = lazy(PayApplication__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b6z_1 = lazy(PayApplication__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c6z_1 = lazy(PayApplication__id$annotations$delegate$lambda);
        this.d6z_1 = Companion_getInstance_0().k2p();
        this.e6z_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.a6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayApplication__id$_get_name_$ref_xg2jw0(), null);
        return tmp0.f2();
      }
      f6y(receiver) {
        return receiver.g6y_1;
      }
      k2j(receiver) {
        return this.f6y(receiver instanceof PayApplication() ? receiver : THROW_CCE());
      }
      o6y(receiver, value) {
        return receiver.p6y(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PayApplication() ? receiver : THROW_CCE();
        return this.o6y(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.b6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayApplication__id$_get_serializer_$ref_43xl3d(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayApplication__id$_get_annotations_$ref_us00kl(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayApplication__id', VOID, VOID, [SerializableProperty()]);
    PayApplication__idClass = $;
  }
  return PayApplication__idClass;
}
var PayApplication__id_instance;
function PayApplication__id_getInstance() {
  if (PayApplication__id_instance === VOID)
    new (PayApplication__id())();
  return PayApplication__id_instance;
}
function PayApplication_created$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function PayApplication_created$_get_name_$ref_pe7tfm() {
  return (p0) => p0.i20();
}
function PayApplication_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayApplication_created$_get_serializer_$ref_oipdsr() {
  return (p0) => p0.h2j();
}
function PayApplication_created$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function PayApplication_created$_get_annotations_$ref_xp19hl() {
  return (p0) => p0.bz();
}
var PayApplication_createdClass;
function PayApplication_created() {
  if (PayApplication_createdClass === VOID) {
    class $ {
      constructor() {
        PayApplication_created_instance = this;
        var tmp = this;
        tmp.f6z_1 = lazy(PayApplication_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g6z_1 = lazy(PayApplication_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h6z_1 = lazy(PayApplication_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.i6z_1 = get_default(Companion_instance).b1m();
        this.j6z_1 = 'now()';
      }
      i20() {
        var tmp0 = this.f6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayApplication_created$_get_name_$ref_pe7tfm(), null);
        return tmp0.f2();
      }
      f6y(receiver) {
        return receiver.j6y_1;
      }
      k2j(receiver) {
        return this.f6y(receiver instanceof PayApplication() ? receiver : THROW_CCE());
      }
      k6z(receiver, value) {
        return receiver.p6y(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PayApplication() ? receiver : THROW_CCE();
        return this.k6z(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayApplication_created$_get_serializer_$ref_oipdsr(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayApplication_created$_get_annotations_$ref_xp19hl(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayApplication_created', VOID, VOID, [SerializableProperty()]);
    PayApplication_createdClass = $;
  }
  return PayApplication_createdClass;
}
var PayApplication_created_instance;
function PayApplication_created_getInstance() {
  if (PayApplication_created_instance === VOID)
    new (PayApplication_created())();
  return PayApplication_created_instance;
}
function PayApplication_submitted$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function PayApplication_submitted$_get_name_$ref_b8dua7() {
  return (p0) => p0.i20();
}
function PayApplication_submitted$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayApplication_submitted$_get_serializer_$ref_fkipm0() {
  return (p0) => p0.h2j();
}
function PayApplication_submitted$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function PayApplication_submitted$_get_annotations_$ref_undeec() {
  return (p0) => p0.bz();
}
var PayApplication_submittedClass;
function PayApplication_submitted() {
  if (PayApplication_submittedClass === VOID) {
    class $ {
      constructor() {
        PayApplication_submitted_instance = this;
        var tmp = this;
        tmp.l6z_1 = lazy(PayApplication_submitted$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m6z_1 = lazy(PayApplication_submitted$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n6z_1 = lazy(PayApplication_submitted$annotations$delegate$lambda);
        this.o6z_1 = null;
        this.p6z_1 = 'null';
      }
      i20() {
        var tmp0 = this.l6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayApplication_submitted$_get_name_$ref_b8dua7(), null);
        return tmp0.f2();
      }
      f6y(receiver) {
        return receiver.k6y_1;
      }
      k2j(receiver) {
        return this.f6y(receiver instanceof PayApplication() ? receiver : THROW_CCE());
      }
      q6z(receiver, value) {
        return receiver.p6y(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PayApplication() ? receiver : THROW_CCE();
        return this.q6z(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayApplication_submitted$_get_serializer_$ref_fkipm0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayApplication_submitted$_get_annotations_$ref_undeec(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayApplication_submitted', VOID, VOID, [SerializableProperty()]);
    PayApplication_submittedClass = $;
  }
  return PayApplication_submittedClass;
}
var PayApplication_submitted_instance;
function PayApplication_submitted_getInstance() {
  if (PayApplication_submitted_instance === VOID)
    new (PayApplication_submitted())();
  return PayApplication_submitted_instance;
}
function PayApplication_attachments$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function PayApplication_attachments$_get_name_$ref_mv3lhi() {
  return (p0) => p0.i20();
}
function PayApplication_attachments$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayApplication_attachments$_get_serializer_$ref_xrxzgz() {
  return (p0) => p0.h2j();
}
function PayApplication_attachments$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function PayApplication_attachments$_get_annotations_$ref_yi4cj3() {
  return (p0) => p0.bz();
}
var PayApplication_attachmentsClass;
function PayApplication_attachments() {
  if (PayApplication_attachmentsClass === VOID) {
    class $ {
      constructor() {
        PayApplication_attachments_instance = this;
        var tmp = this;
        tmp.r6z_1 = lazy(PayApplication_attachments$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s6z_1 = lazy(PayApplication_attachments$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t6z_1 = lazy(PayApplication_attachments$annotations$delegate$lambda);
        this.u6z_1 = emptyList();
        this.v6z_1 = 'emptyList()';
      }
      i20() {
        var tmp0 = this.r6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayApplication_attachments$_get_name_$ref_mv3lhi(), null);
        return tmp0.f2();
      }
      f6y(receiver) {
        return receiver.m6y_1;
      }
      k2j(receiver) {
        return this.f6y(receiver instanceof PayApplication() ? receiver : THROW_CCE());
      }
      w6z(receiver, value) {
        return receiver.p6y(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PayApplication() ? receiver : THROW_CCE();
        return this.w6z(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayApplication_attachments$_get_serializer_$ref_xrxzgz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayApplication_attachments$_get_annotations_$ref_yi4cj3(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayApplication_attachments', VOID, VOID, [SerializableProperty()]);
    PayApplication_attachmentsClass = $;
  }
  return PayApplication_attachmentsClass;
}
var PayApplication_attachments_instance;
function PayApplication_attachments_getInstance() {
  if (PayApplication_attachments_instance === VOID)
    new (PayApplication_attachments())();
  return PayApplication_attachments_instance;
}
function PayApplication_readBy$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function PayApplication_readBy$_get_name_$ref_w3qnxr() {
  return (p0) => p0.i20();
}
function PayApplication_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayApplication_readBy$_get_serializer_$ref_v2ddx4() {
  return (p0) => p0.h2j();
}
function PayApplication_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function PayApplication_readBy$_get_annotations_$ref_facpmk() {
  return (p0) => p0.bz();
}
var PayApplication_readByClass;
function PayApplication_readBy() {
  if (PayApplication_readByClass === VOID) {
    class $ {
      constructor() {
        PayApplication_readBy_instance = this;
        var tmp = this;
        tmp.x6z_1 = lazy(PayApplication_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y6z_1 = lazy(PayApplication_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z6z_1 = lazy(PayApplication_readBy$annotations$delegate$lambda);
        this.a70_1 = emptySet();
        this.b70_1 = 'emptySet()';
      }
      i20() {
        var tmp0 = this.x6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayApplication_readBy$_get_name_$ref_w3qnxr(), null);
        return tmp0.f2();
      }
      f6y(receiver) {
        return receiver.n6y_1;
      }
      k2j(receiver) {
        return this.f6y(receiver instanceof PayApplication() ? receiver : THROW_CCE());
      }
      c70(receiver, value) {
        return receiver.p6y(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PayApplication() ? receiver : THROW_CCE();
        return this.c70(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayApplication_readBy$_get_serializer_$ref_v2ddx4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z6z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayApplication_readBy$_get_annotations_$ref_facpmk(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayApplication_readBy', VOID, VOID, [SerializableProperty()]);
    PayApplication_readByClass = $;
  }
  return PayApplication_readByClass;
}
var PayApplication_readBy_instance;
function PayApplication_readBy_getInstance() {
  if (PayApplication_readBy_instance === VOID)
    new (PayApplication_readBy())();
  return PayApplication_readBy_instance;
}
//region block: exports
export {
  get_description as get_descriptionv6nk17rgbaxj,
  get_number as get_number1dhanv5t6fc1y,
  preparePayApplicationFields as preparePayApplicationFields2nbs32s76xjhm,
  get_project as get_project8eilj2kht5hl,
};
//endregion

//# sourceMappingURL=PayApplicationFields.mjs.map
